module.exports = __webpack_public_path__ + "img/US.936feee6.svg";